<script>
    import ProfilePictureModal from "./ProfilePictureModal";

    export default {
        components: {
            ProfilePictureModal,
        },

        props: {
            user: {
                type: Object,
                required: true,
            }
        },

        methods: {
            showProfilePicture() {
                this.$modal.show(ProfilePictureModal, {
                    pictureUrl: `/user/${this.user.id}/photo?w=500&h=500`,
                }, {height: 500, width: 500});
            }
        }
    }
</script>
